import {IStateProps} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {dictionaryPipe} from '../../../../shared/pipes/dictionary';
import {Field} from 'redux-form';
import {BaseFieldWrapper} from '../../../../shared/components/baseField';
import {useStyles} from '../../../../shared/hooks/styles';
import {getProfileApplicationsAndDocumentsFilterName} from '../filter';
import {Button} from '../../../../shared/components/button';
import {Text} from '../../../../shared/components/text';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {capitalize} from '../../../../shared/utils/text';

export default ({
  containerStyle,
  itemStyle,
  groupStyle,
  showButton,
  onPressButton,
  typeApplicationDictionary,
  statusDictionary,
}: IStateProps) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {
      paddingTop: 12,
    },
    item: {
      marginBottom: 10,
    },
    group: {
      paddingVertical: 12,
      paddingHorizontal: 20,
    },
    groupButton: {
      alignItems: 'center',
    },
    groupBorderTop: {
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    groupTitle: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.h6Light),
      marginBottom: 10,
    },
    label: {
      ...theme.fonts.body,
    },
    button: {
      width: 200,
    },
  }));
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={[styles.group, groupStyle]}>
        <Text testID='request-filter-request-type-id' style={styles.groupTitle}>
          Тип заявления
        </Text>
        {Object.keys(typeApplicationDictionary).map((key) => (
          <View key={key} style={[styles.item, itemStyle]}>
            <Field
              component={BaseFieldWrapper}
              type='checkbox'
              name={getProfileApplicationsAndDocumentsFilterName(key, 'typeApplication')}
              label={capitalize(dictionaryPipe(key, typeApplicationDictionary))}
              labelStyle={styles.label}
            />
          </View>
        ))}
      </View>
      <View style={[styles.group, styles.groupBorderTop, groupStyle]}>
        <Text testID='request-filter-request-status-id' style={styles.groupTitle}>
          Статус заявления
        </Text>
        {Object.keys(statusDictionary).map((key) => (
          <View key={key} style={[styles.item, itemStyle]}>
            <Field
              component={BaseFieldWrapper}
              type='checkbox'
              name={getProfileApplicationsAndDocumentsFilterName(key, 'status')}
              label={dictionaryPipe(key, statusDictionary)}
              labelStyle={styles.label}
            />
          </View>
        ))}
      </View>
      {showButton ? (
        <View style={[styles.group, styles.groupButton, styles.groupBorderTop, groupStyle]}>
          <Button
            id='applications-filter-show'
            text='Показать'
            type='secondary'
            style={styles.button}
            onPress={onPressButton}
          />
        </View>
      ) : null}
    </View>
  );
};
